import { Alert, AlertDescription, AlertIcon, AlertTitle, Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface Props {
  title?: string;
  message?: string;
}

export const CriticalError = ({ title, message }: Props) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Alert status="error" rounded="md">
        <AlertIcon />
        <AlertTitle>{title ?? t("Wups!")}</AlertTitle>
        <AlertDescription>{message ?? `${t("Something went wrong and our team has been notified")}!`}</AlertDescription>
      </Alert>
    </Box>
  );
};
